const ImagesConstants = {
    RELEASE: {
        DATABOOK_LANDING: require("../assets/images/release/RV130_1.jpg"),
        OPTIMIZED_SEARCH_DROP: require("../assets/images/release/RV130_2.jpg"),
        ROLE_BASED_ACCESS: require("../assets/images/release/RV130_3.jpg"),
        IMPROVED_LANDING_PAGE: require("../assets/images/release/RV130_4.jpg"),
        DATABOOK_LAND_BANNER: require("../assets/images/release/RV130_banner1.jpg"),
        // NOTIFICATIONS: require("../assets/images/Notifications.png"),
        // HELP: require("../assets/images/Help.png"),
        // DATABOOK_NAV: require("../assets/images/Databook.png"),
        // INSIGHTS: require("../assets/images/Insights.png"),
    },

};

export default ImagesConstants;
